import { isValidNumber } from './review-latency-utils';

function withSign(value: number, formatted: string): string {
  const prefix = value > 0 ? '+' : value < 0 ? '-' : '';
  return `${prefix}${formatted}`;
}

export function formatHours(hours: number | null | undefined): string {
  if (!isValidNumber(hours)) return '—';
  const totalMinutes = Math.round(hours * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  if (h > 0 && m > 0) return `${h}h ${m}m`;
  if (h > 0) return `${h}h`;
  return `${m}m`;
}

export function formatSignedHours(hours: number | null | undefined): string {
  if (!isValidNumber(hours)) return '—';
  return withSign(hours, formatHours(Math.abs(hours)));
}

export function formatAxisHours(hours: number | null | undefined): string {
  if (!isValidNumber(hours)) return '—';
  if (hours >= 10) return `${Math.round(hours)}h`;
  if (hours >= 1) return `${hours.toFixed(1).replace(/\.0$/, '')}h`;
  return `${Math.round(hours * 60)}m`;
}

export function formatCount(count: number | null | undefined): string {
  if (!isValidNumber(count)) return '—';
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Math.round(count));
}

export function formatPerDay(count: number | null | undefined): string {
  if (!isValidNumber(count)) return '—';
  return `${new Intl.NumberFormat('en-US', { maximumFractionDigits: 1 }).format(count)}/day`;
}

export function formatDeltaPerDay(count: number | null | undefined): string {
  if (!isValidNumber(count)) return '—';
  return withSign(count, formatPerDay(Math.abs(count)));
}

export function formatChartDate(dateStr: string): string {
  const d = new Date(dateStr + 'T00:00:00Z');
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
}
